<main>
  <div class="content">
    <section>
      <p-message severity="warn"> You are not authorized to access this page. </p-message>
    </section>
  </div>
</main>
